import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy, EventEmitter, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog'; import { UserService } from '../../../../shared/services/user.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { NewInspectionService } from '../../services/new-inspection.service';
import { SystemInspectionDetailView, ComponentOnSystemInspectionViewModel, WornPercentageCalculateViewModel, InspectionDraftImagesView, SwapRollerEndPoint, PopupEndPoint } from '../../models/create-inspection.model';
import { ActivatedRoute } from '@angular/router';
import { MeasurementToolsViewModel } from '../../../measurement-points-admin/model/measurement-points.model';
import { AddCommentOnComponentComponent } from '../add-comment-on-component/add-comment-on-component.component';
import { AppService } from '../../../../../app/app.service';
import { SetupUndercarriageService } from '../../../../modules/setup-undercarriage';
import { ManageEquipmentService } from '../../../../modules/manage-equipment/manage-equipment.service';
import { ComponentType } from '../../../../entities';
import { SwapRollerModelComponent } from '../swap-roller-model/swap-roller-model.component';
import { CustomeEvaluationRangeVM } from '../../../../modules/CustomEval/custom-eval.model';
import { TrackFrameConfigurationComponent } from '../../../../../app/modules/manage-equipment/components/track-frame-configuration/track-frame-configuration.component';
import { MultiplePhotoUploadComponent } from '../../../../../app/modules/interpretation/components/multiple-photo-upload/multiple-photo-upload.component';
import { InterpretationService } from '../../../../../app/modules/interpretation/interpretation.service';
import { toolType, toolTypePassFail, toolTypeYesNo } from '../../../../shared/enums/allEnums';
import { BogieShim } from '../../../../shared/components/bogie-shim/bogie-shim-model';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { ComponentModel } from '../../../../../app/modules/interpretation/models/interpretation.model';
import { ComponentImageHistoryComponent } from '../../../../../app/modules/interpretation/components/component-image-history/component-image-history.component';
import { ComponentCommentModalComponent } from '../../../../../app/modules/interpretation/components/component-comment-modal/component-comment-modal.component';


@Component({
  selector: 'app-inspection-systems',
  templateUrl: './inspection-systems.component.html',
  styleUrls: ['./inspection-systems.component.scss'],
  // animations: [
  //   trigger(
  //     'slideOut', [
  //       transition(':enter', [
  //         style({ 'max-height': '0' }),
  //         animate('5s', keyframes([
  //           style({ 'max-height': '200px', offset: 0 }),
  //           style({ 'max-height': '400px', offset: 0.3 }),
  //           style({ 'max-height': '600px', offset: 0.6 }),
  //           style({ 'max-height': '1400px', offset: 0.9 }),
  //         ]))
  //       ])
  //     ]
  //   )],
})
export class InspectionSystemsComponent implements OnInit, OnDestroy {

  @Input() inspectionDraftId: number = -1;
  inspectionId: number;
  @Input() side: number = -1;
  @Input() systemType: number = -1;
  @Input() impact: number = -1;
  @Input() smuReading: number;
  @Input() pmuReading: number;
  @Input() totalInspDistance: number = 0;
  bogieShimRight: BogieShim[] = [];
  bogieShimLeft: BogieShim[] = [];
  @Input() EvalautionRange: CustomeEvaluationRangeVM;
  imageUrl = '';
  @Input() BogieShimRight: BogieShim[] = [];
  @Input() BogieShimLeft: BogieShim[] = [];
  @Input() EnableBogieShim: boolean = false;
  @Input() ShowCannonType: boolean = false;
  @Input() ShowFrameConfigurtaion: boolean = false;
  isInspector = false;
  isInterpreter = false;
  isRopeShovel = false;

  system: SystemInspectionDetailView;
  loadingSystems = true;
  filteredTools: MeasurementToolsViewModel[];

  equipmentId: number;
  systemTitle: string;
  creatingNewInspection = false;
  @Input() isRSH: boolean = false;
  @Input() FamilyName: string = "";
  @Input() FamilyImage_Chain: string = "";

  @Input() FamilyImage_Frame: string = "";

  @Input() ShowHideCRoller: boolean;
  @Input() EnableDistTravelledTracking: boolean;
  @Input() System: SystemInspectionDetailView;
  //ToolType is enum where we have all the tool types
  ToolType = toolType;
  selectedValue: string;
  toolYesNo = toolTypeYesNo;
  toolPassFail = toolTypePassFail;
  isManuallyChanged: boolean = false;
  @Output() measurementChanged = new EventEmitter<boolean>();
  @Output() childSystemUpdated = new EventEmitter<SystemInspectionDetailView>();
    @Output() addImagesSystem = new EventEmitter<SystemInspectionDetailView>();
  EquipmentDetails;
  showFrameConfigurtaion: boolean = false;
  showCannonType: boolean = false;
  enableBogieShim: boolean = false;
  isBogieLoad: boolean = false;
  @Input() InspId: number = -1;
  isImageUrl: boolean = false;
  @Input() uom: string
  userUOM: string;
  constructor(
    private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _cdr: ChangeDetectorRef,
    private _user: UserService,
    private _loading: LoadingService,
    private _newInspectionService: NewInspectionService,
    private route: ActivatedRoute,
    private _appSerivce: AppService,
    private _setupService: SetupUndercarriageService,
    private _equipmentService: ManageEquipmentService,
    private _interpService: InterpretationService,
    private _pref: PreferencesService
  ) { }
  UTEquivalenetEnabled: boolean = false;
  UTEqu: string;
  isEnableMaxRange: boolean;
  ngOnInit() {
    this.equipmentId = +this.route.snapshot.paramMap.get('id');
    this.inspectionId = +this.route.snapshot.paramMap.get('id2');
    // if(this.inspectionId > 0){
    //   this.getInspection();
    // }  
    this.getUserUOM();
    this._appSerivce.getApplicationConfigValue("UTEquivalentEnabled").subscribe(result => {
      this.UTEqu = result
      if (this.UTEqu == "1") {
        this.UTEquivalenetEnabled = true;
      } else {
        this.UTEquivalenetEnabled = false;
      }
    });


    this._appSerivce.getApplicationConfigValue("EnableMaxRangeForEvaluation").subscribe(result => {

      if (result == "1") {
        this.isEnableMaxRange = true;
      } else {
        this.isEnableMaxRange = false;
      }
    });
    if (this.inspectionId === 0) {
      this.creatingNewInspection = true;

    } else
      this.creatingNewInspection = false;

    this.checkPermissions();
    this.assignTitle();
    // this.getEquipmentDetails();
    this.enableBogieShim = this.EnableBogieShim;
    this.showCannonType = this.ShowCannonType;
    this.showFrameConfigurtaion = this.ShowFrameConfigurtaion;
    this.bogieShimLeft = this.BogieShimLeft;
    this.bogieShimRight = this.BogieShimRight;
  }
  ngOnDestroy(): void {
    console.log('destoried');
  }

  getUserUOM() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOM = res.UnitOfMeasurementName;
    })
  }

  // getInspection(){
  //   this._newInspectionService.getInspection(this.equipmentId, this.inspectionId).subscribe((r: any) => {
  //     this.bogieShimLeft = r.BogieShimLeft;
  //     this.bogieShimRight = r.BogieShimRight;
  //     console.log("BogieShimLeft",this.bogieShimLeft);
  //     console.log("BogieShimRight",this.bogieShimRight);
  //   });
  // }
  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case 'Customer Admin':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }
  assignTitle() {

    if (this.systemType === 1) {
      this.side === 1 ? this.systemTitle = 'Left Side Chain' : this.systemTitle = 'Right Side Chain';
    } else {
      this.side === 1 ? this.systemTitle = 'Left Side Frame' : this.systemTitle = 'Right Side Frame';
    }
  }


  GetEvalColour(comp: ComponentOnSystemInspectionViewModel, worn: number) {
    var compType = comp.CompartTypeId;

    if (comp.ToolId === toolType.Eval) {
      if (comp.EvalCode == '')
        return 'Eval-U';
      else
        return 'Eval-' + comp.EvalCode;
    }

    if(comp.ToolId === toolType.ConditionAssessment){
      if(comp.EvalCode === 'A') return 'Eval-A';
      else if(comp.EvalCode === 'B') return 'Eval-B';
      else if(comp.EvalCode === 'X') return 'Eval-X';

    }

    if (comp.MeasurementReading === -1 || comp.ToolId === toolType.YESorNO || comp.ToolId === toolType.PassorFail) {
      return 'Eval-U';
    }

    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 231://Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.BushC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ShoeC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 233://Idler
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 234://carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CarrierRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 235://track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.TrackRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 236://Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.SprocketC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 240://Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ElongationC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 417://Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CrawlerGuideC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 446://RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.RSRearIdlerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }


      case 237://Gurd 

        if (worn <= 30)
          return 'Eval-A';
        else if (worn <= 50)
          return 'Eval-B';
        else if (worn <= 70)
          return 'Eval-C';
        else
          return 'Eval-X';

      default:
        break;
    }
  }


  openTrackCofiguration(selectedType: number, selectedValue: number, systemId: number) {
    const dialogRef = this._dialog.open(TrackFrameConfigurationComponent, {
      disableClose: true,
      width: '1032px',
      data: {
        selectedType: selectedType,
        selectedValue: selectedValue,
        systemId: systemId,
        equipmentId: this.equipmentId
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (selectedType == 1) {
        this.system.ToeOutFrame = res;
        if (selectedValue != res) {
          //need to update 
        }
      } else {
        this.system.CastFrame = res;
        if (selectedValue != res) {
          //need to update 
        }
      }


    });
  }
  loadSystem(smu, pmu) {
    this.smuReading = smu;
    this.pmuReading = pmu;
    if (this.pmuReading == null || this.pmuReading == undefined) {
      this.pmuReading = 0;
    }
    //if (this.inspectionDraftId !==   this.inspectionId && this.inspectionDraftId !== -1 && this.inspectionDraftId !== undefined && this.inspectionId !== undefined) {
    if (this.inspectionId <= 0) {
      this._newInspectionService.getSystemViewSP(this.equipmentId, this.inspectionDraftId, this.side, this.systemType, smu, this.pmuReading, this.totalInspDistance).subscribe(s => {
        this.system = s.Data;
        //this.system = s;
        console.log("system", this.system);
        this.system.Components?.forEach(c => {
          c.Side = this.side;        // existing
          c.isImageUrl = true;       // add new property
        });

        this.childSystemUpdated.emit(this.system);
        this.isImageUrl = true;
        console.log(this.system);
        //console.log(this.system.Components.length);
        console.log("system", this.system.Components.map(x => x.ToolId));
        const DefualtToolId = this.system.Components.map(x => x.ToolId);


        if (this.ShowHideCRoller == false) {

          this.system.Components = this.system.Components.filter(
            (component) => component.CompartTypeId !== 234
          );

        }

        this.system.Components.map(x => {
          if (x.CompartTypeId == 230) {
            if (this.EvalautionRange.LinkC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 231) {
            if (this.EvalautionRange.BushC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 232) {
            if (this.EvalautionRange.ShoeC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 233) {
            if (this.EvalautionRange.IdlerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 234) {
            if (this.EvalautionRange.CarrierRollerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 235) {
            if (this.EvalautionRange.TrackRollerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 236) {
            if (this.EvalautionRange.SprocketC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 240) {
            if (this.EvalautionRange.ElongationC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 417) {
            if (this.EvalautionRange.CrawlerGuideC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 446) {
            if (this.EvalautionRange.RSRearIdlerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }

        })
        if (this.FamilyName !== 'Rope Shovel') {
          this.isRopeShovel = false;
          if (!this.isRopeShovel) {
            this.system.Components.filter(x => {
              if (x.CompartTypeId === 236) {
                // this.filteredTools = this.system.Components[0].PossibleTools.filter(x => x.ToolId !== 5 && x.ToolId !== 6 && x.ToolId !== 7  && x.ToolId !== 8 );
                x.PossibleTools = x.PossibleTools.filter(x => x.ToolId !== 5 && x.ToolId !== 6 && x.ToolId !== 7 && x.ToolId !== 8);

              }
            });

          }

        }
        else {
          this.isRopeShovel = true;
        } // this.inspectionId = s.InspectionDraftId;
        //this.getEquipmentDetails();
        this.loadingSystems = false;
        this.isBogieLoad = true;
      });
    }
    else {
      this._newInspectionService.getSystemViewForEditSP(this.equipmentId, this.inspectionId, this.side, this.systemType, smu, this.pmuReading, this.totalInspDistance).subscribe(s => {
        this.system = s;
        //this.system = s;
        console.log("system", this.system);
        this.system.Components?.forEach(c => { c.Side = this.side; });
        this.childSystemUpdated.emit(this.system);
        this.isImageUrl = true;
        console.log(this.system);
        //console.log(this.system.Components.length);
        console.log("system", this.system.Components.map(x => x.ToolId));
        const DefualtToolId = this.system.Components.map(x => x.ToolId);


        if (this.ShowHideCRoller == false) {

          this.system.Components = this.system.Components.filter(
            (component) => component.CompartTypeId !== 234
          );

        }

        this.system.Components.map(x => {
          if (x.CompartTypeId == 230) {
            if (this.EvalautionRange.LinkC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 231) {
            if (this.EvalautionRange.BushC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 232) {
            if (this.EvalautionRange.ShoeC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 233) {
            if (this.EvalautionRange.IdlerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 234) {
            if (this.EvalautionRange.CarrierRollerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 235) {
            if (this.EvalautionRange.TrackRollerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 236) {
            if (this.EvalautionRange.SprocketC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 240) {
            if (this.EvalautionRange.ElongationC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 417) {
            if (this.EvalautionRange.CrawlerGuideC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }
          if (x.CompartTypeId == 446) {
            if (this.EvalautionRange.RSRearIdlerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;
          }

        })
        if (this.FamilyName !== 'Rope Shovel') {
          this.isRopeShovel = false;
          if (!this.isRopeShovel) {
            this.system.Components.filter(x => {
              if (x.CompartTypeId === 236) {
                // this.filteredTools = this.system.Components[0].PossibleTools.filter(x => x.ToolId !== 5 && x.ToolId !== 6 && x.ToolId !== 7  && x.ToolId !== 8 );
                x.PossibleTools = x.PossibleTools.filter(x => x.ToolId !== 5 && x.ToolId !== 6 && x.ToolId !== 7 && x.ToolId !== 8);

              }
            });

          }

        }
        else {
          this.isRopeShovel = true;
        } // this.inspectionId = s.InspectionDraftId;
        //this.getEquipmentDetails();
        this.loadingSystems = false;
        this.isBogieLoad = true;
      });
    }

    console.log("this.system___", this.system)
  }

  sanitize(image: string) {
    //return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    if (!this.isImageUrl)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    else
      return image;
  }

  reloadSystem() {
    this.loadSystem(this.smuReading, this.pmuReading);
  }

  showPosition(position: number, compartTypeId: number): string {

    let hasSameComponent = this.system.Components.filter(x => x.CompartTypeId == compartTypeId && x.IsChild == false);
    if (hasSameComponent.length > 1) {
      return this.getPositionStringDoubleComponents(position, compartTypeId);
    } else {
      return this._appSerivce.getPositionString(position, compartTypeId);
    }

  }

  getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
    if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
    if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 || Pos === undefined) {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';

    }
    if (CompartTypeId == 446)
      return 'Rear'
    return Pos.toString();
  }

  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  viewComponentPhoto(image: InspectionDraftImagesView, c: ComponentOnSystemInspectionViewModel, ComingFrom?: number, systemId?: number, IsEditAddInspection:boolean=false) {
    if(c==undefined)
    c=null;
    //const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    const viewPhotoModalRef = this._dialog.open(MultiplePhotoUploadComponent, {
      width: '800px',
      disableClose: true,
      data: {
        inspectionDraftDetailId: c?.InspectionDraftDetailId,
        photoId: image.Id,
        equipmentId: this.equipmentId,
        inspectionDraftId: this.inspectionDraftId,
        photo: c?.TempOneImageOnly,
        IsImageUrl: this.isImageUrl,
        inspImg: c?.Images,
        comingFrom: ComingFrom,
        systemId: systemId,
        inspectionId: this.inspectionId,
        IsEditAddInspection: IsEditAddInspection
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(result => {
      if (result) {
        if(result?.deletedImageIds?.length>0  ){

        this.system.SystemImages = (this.system.SystemImages || []).filter(
              img => !result.deletedImageIds.includes(img.Id) // 👈 IMPORTANT
            );
        }
        //console.log(result.Images);
        c.Images = result.Images.map(([imagePath, image]) => ({
          ImagePath: imagePath,
          Image: image
        }));
        c.TempOneImageOnly = c.Images.length > 0 ? c.Images[0] : null;
        console.log(c.Images);
        console.log(c.TempOneImageOnly);
        this.childSystemUpdated.emit(this.system);
        //this.loadPhoto(c, event);
      }
      // this.loadSystem(this.smuReading, this.pmuReading);
    });

  }

  IntendToSwapRoller(component: ComponentOnSystemInspectionViewModel) {
    if (this.creatingNewInspection && (component.CompartTypeId === ComponentType.TrackRoller || component.CompartTypeId === ComponentType.CarrierRoller)) {
      const rollers = this.system.Components.filter(a => a.CompartTypeId === component.CompartTypeId);
      if (rollers !== null && rollers.length > 1) {
        const swapModel = this._dialog.open(SwapRollerModelComponent, {
          data: {
            selectedComponent: component,
            allRollers: rollers,
            comingFrom: SwapRollerEndPoint.CreateNewInspection,
          }
        });
        swapModel.afterClosed().subscribe(swaped => {

        });
      } else {
        console.log('Not suitable for swaping positions');
      }
    } else {
      console.log('Not suitable for swaping positions');
    }
  }

  uploadedPhoto() {

  }
  AddComment(c: ComponentOnSystemInspectionViewModel) {
    const viewCommentModalRef = this._dialog.open(AddCommentOnComponentComponent, {
      width: '1032px',
      data: {
        // inspectionId: ,
        inspectionDetailDraftId: c.InspectionDraftDetailId,
        equipmentId: this.equipmentId,
        comment: c.Comment,
        CompartTypeId: c.CompartTypeId,
      }
    });
    viewCommentModalRef.afterClosed().subscribe(reloadComment => {
      if (reloadComment) {
        // this.loadSystem(this.smuReading, this.pmuReading);
        c.Comment = reloadComment;
        console.log(this.system);
        this.childSystemUpdated.emit(this.system);
        //this.loadComment(c);
      }
    });


    // this. = this._data.inspectionDraftId;
    // this. = this._data.inspectionDetailDraftId;
    // this. = this._data.equipmentId;
  }

  loadComment(component: ComponentOnSystemInspectionViewModel) {
    this._newInspectionService.GetComponentComment(component.InspectionDraftDetailId, component.EquipmentId).subscribe(res => {
      if (res.m_Item1 == true) {
        component.Comment = res.m_Item2;
        //this.updateComment = res.m_Item2;
      }
    })
    //  component.Comment = this.updateComment;

  }


  loadPhoto(component: ComponentOnSystemInspectionViewModel, event: any) {
if(!component.TempOneImageOnly)
component.TempOneImageOnly = new InspectionDraftImagesView();
    component.TempOneImageOnly.Image = event.image;
    component.TempOneImageOnly.ImagePath = event.imagePath;
    //component.Images[0].Image = event.image;
    //component.Images[0].ImagePath = event.imagePath;
    if (!component.Images)
      component.Images = [];
    component.Images.push({
      Image: event.image,
      ImagePath: event.imagePath,
      Id: 0,
      Comment: null,
      Title: null
    });
    this.childSystemUpdated.emit(this.system);
    // console.log("event.image", event);
    // console.log("photo", component.TempOneImageOnly.Image);
    // console.log("component", component);
    // this._interpService.getInspectionDetailPhotoList(component.InspectionDraftDetailId,this.equipmentId,0).subscribe(res=>{
    //   if(res.photo1!=null){

    //     component.TempOneImageOnly.Image = res.photo1;
    //     //this.updateComment = res.m_Item2;
    //   }else{
    //     component.TempOneImageOnly.Image = '';

    //   }
    // })
    //component.Comment = this.updateComment;

  }

  //updateComponentMeasurement(value, component: ComponentOnSystemInspectionViewModel) {
  updateComponentMeasurement(value: number, inspectionDetailId: number, event: any, component: ComponentOnSystemInspectionViewModel) {
    this._loading.startLoading();

    component.MeasurementReading = event != null ? event.target.value : value;

    const queyModel = new WornPercentageCalculateViewModel();
    queyModel.EquipmentId = this.equipmentId;
    queyModel.GeneralEqunitId = component.GeneralEqUnitId;
    queyModel.Impact = this.impact !== -1 ? this.impact : 2; // todo  access parent Inspection
    queyModel.Reading = component.MeasurementReading;//value;
    queyModel.ToolId = component.ToolId;
    queyModel.IsMeasuredInInches = component.IsMeasuredInInches;
    queyModel.EvaluationRange = this.EvalautionRange;
    queyModel.CompartTypeId = component.CompartTypeId;

    const shouldCallWornCalc =
      component.ToolId !== toolType.YESorNO &&
      component.ToolId !== toolType.PassorFail &&
      component.ToolId !== toolType.Eval && component.ToolId !== toolType.ConditionAssessment;

    if (shouldCallWornCalc) {
      this._newInspectionService.getWornPercentageOnComponent(queyModel).subscribe(r => {
        component.Eval = r.m_Item2;
        component.WornPercentage = r.m_Item1;
        this._loading.finishedLoading();
        console.log(this.system);
        //this._newInspectionService.saveInspectionComponentDetailDraft(component, this.creatingNewInspection).subscribe();
      });
    } else {
      this._loading.finishedLoading();
      //this._newInspectionService.saveInspectionComponentDetailDraft(component, this.creatingNewInspection).subscribe();
      this.GetEvalColour(component, component.WornPercentage);
      console.log(this.system);
    }
    this.childSystemUpdated.emit(this.system);
  }

  loadSelectedComponentMeasurement(component: ComponentOnSystemInspectionViewModel, inspectionDetailsId: number) {
    this._newInspectionService.GetComponentMeasurementInspectionDraft(inspectionDetailsId, component.EquipmentId).subscribe(res => {
      if (res != null) {
        component.WornPercentage = res.WornPercentage;
        component.EvalCode = res.EvalCode;
      }
    })
  }
  changeEval(component: ComponentOnSystemInspectionViewModel, selectedEval: string, toolId: number=0 ) {
    //const measurement = this._appSerivce.getEvalToolMeasurementPoint(selectedEval);
    let CompartTypeId=0;
 if(toolId== toolType.ConditionAssessment){
     toolId== toolType.ConditionAssessment;
     selectedEval= selectedEval=='Good'?'A':selectedEval=='Monitor'?'B':'X';
     CompartTypeId=0;
    }else{
      toolId== toolType.Eval;
      CompartTypeId=component.CompartTypeId;
    }

    const measurement = this._appSerivce.getEvalToolMeasurementPoint_Worn(selectedEval, CompartTypeId, this.EvalautionRange, this.isEnableMaxRange);
    component.IsMeasuredInInches = false;
    component.MeasurementReading = measurement;
    component.EvalCode = selectedEval;
    this.updateComponentMeasurement(component.MeasurementReading, component.InspectionDraftDetailId, null, component);

  }

  changeMeasurementUnit(component: ComponentOnSystemInspectionViewModel, isMeasurementInInches: boolean) {
    component.IsMeasuredInInches = isMeasurementInInches;
    this.updateComponentMeasurement(component.MeasurementReading, component.InspectionDraftDetailId, null, component);
  }

  changeTool(tool: MeasurementToolsViewModel, component: ComponentOnSystemInspectionViewModel) {
    component.ToolId = tool.ToolId;
    component.ToolName = tool.ToolName;
    if (component.ToolId !== toolType.Eval && component.ToolId !== toolType.ConditionAssessment) 
      this.updateComponentMeasurement(component.MeasurementReading, component.InspectionDraftDetailId, null, component);
    else if (component.ToolId === toolType.Eval) {
      this.changeEval(component, 'A');
    }else if (component.ToolId === toolType.ConditionAssessment) {
      this.changeEval(component, 'Good',toolType.ConditionAssessment);
    }
    if (component.ToolId === toolType.YESorNO) {
      this.updateComponentMeasurement(1, component.InspectionDraftDetailId, null, component);
    }
    if (component.ToolId === toolType.PassorFail) {
      this.updateComponentMeasurement(1, component.InspectionDraftDetailId, null, component);
    }
  }
  onToolOptionSelect(component: ComponentOnSystemInspectionViewModel, value: number) {
    if (value === toolTypeYesNo.Yes || value === toolTypePassFail.Pass) {
      this.updateComponentMeasurement(value, component.InspectionDraftDetailId, null, component);
    }
    else {
      this.updateComponentMeasurement(value, component.InspectionDraftDetailId, null, component);
    }
  }
  getImage_(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }



  getFamilyDetails(value: string) {

    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        let familydetails = res;
        familydetails.map(x => {
          if (x.typedesc === value) {
            this.FamilyImage_Chain = x.ChainImage;
            this.FamilyImage_Frame = x.FrameImage;
          }
        });
      }
    });

  }

  validateAndUpdateMeasurementsOnNext() {
    // Loop through each component in the system
    for (let component of this.system?.Components) {
      // Only trigger calculation if the component hasn't been manually changed
      if (!this.isManuallyChanged) {
        // For YES/NO, PASS/FAIL, and EVAL, skip worn percentage calculation
        if (
          component.ToolId === toolType.YESorNO ||
          component.ToolId === toolType.PassorFail ||
          component.ToolId === toolType.Eval
        ) {
          // Only save the measurement if not yet saved
          this._newInspectionService.saveInspectionComponentDetailDraft(
            component,
            this.creatingNewInspection
          ).subscribe();
        } else {
          // Calculate and then save
          const queryModel = new WornPercentageCalculateViewModel();
          queryModel.EquipmentId = this.equipmentId;
          queryModel.GeneralEqunitId = component.GeneralEqUnitId;
          queryModel.Impact = this.impact !== -1 ? this.impact : 2;
          queryModel.Reading = component.MeasurementReading;
          queryModel.ToolId = component.ToolId;
          queryModel.IsMeasuredInInches = component.IsMeasuredInInches;
          queryModel.EvaluationRange = this.EvalautionRange;
          queryModel.CompartTypeId = component.CompartTypeId;

          this._newInspectionService.getWornPercentageOnComponent(queryModel).subscribe(r => {
            component.Eval = r.m_Item2;
            component.WornPercentage = r.m_Item1;

            this._newInspectionService.saveInspectionComponentDetailDraft(
              component,
              this.creatingNewInspection
            ).subscribe();
          });
        }
      }
    }
  }

  getEquipmentDetails() {
    this._equipmentService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
      this.EquipmentDetails = equipment;
      this.showCannonType = this.EquipmentDetails.EnableCannonType;
      this.showFrameConfigurtaion = this.EquipmentDetails.EnableFrameConfiguration;
      this.enableBogieShim = this.EquipmentDetails.EnableBogieShim;
    });
    if (this.EquipmentDetails !== null) { }
  }



  /**
 * Checks if the given component Id is a parent component. Returns true if the component
 * is a parent.
 * @param componentId The id of the component we want to know is a parent or child.
 */
  // isParent(componentId: number): boolean {
  //   const component = this.getComponent(componentId);
  //   const children = this.system.Components.filter(c => c.CompartTypeId === component.CompartTypeId && c.IsChild);
  //   if (children.length > 0) {
  //     const childrenWithParent = this.system.Components.filter(c => c.CompartTypeId === component.CompartTypeId);
  //     if (childrenWithParent[0].CompartId === componentId) return true;
  //   }
  //   return false;
  // }
  // getComponent(componentId: number): ComponentOnSystemInspectionViewModel {
  //   return this.system.Components.find(c => c.CompartId === componentId);
  // }

  // getChildRowPosition(componentId: number): string {
  //   const component = this.getComponent(componentId);
  //   const children = this.system.Components.filter(c => c.CompartTypeId === component.CompartTypeId && c.IsChild);
  //   if (children[0].CompartId === componentId) return '--extended';
  //   if (children[children.length - 1].CompartId === componentId) return '--half';
  //   return '';
  // }



  /**
   * Gets the component from the given Id.
   * @param componentId The ID component we want to get.
   * @returns The component model.
   */

  getComponent(componentId: number): ComponentOnSystemInspectionViewModel {
    return this.system.Components.find(c => c.GeneralEqUnitId === componentId);
  }
  /**
   * Determines if the child component row displayed in the table is in the first
   * position, somewhere in the middle of the list, or in the last position.
   * We need to know this so we can determine how to draw the lines that connect
   * the child components to the parent to indicate they are children to the user.
   * @param componentId The Id of the component we are drawing the row for.
   * @returns The css class extension to draw the correct line based on the position.
   */
  getChildRowPosition(componentId: number): string {
    const component = this.getComponent(componentId);
    //const children = this.system.Components.filter(c => c.CompartTypeId === component.CompartTypeId && c.IsChild);
    const children = this.system.Components.filter(c => c.ParentComponentId === component.ParentComponentId);
    if (children.length > 0) {
      if (children[children.length - 1].GeneralEqUnitId === componentId) return '--half';
      else if (children[0].GeneralEqUnitId === componentId) return '--extended';
    }
    return '';
  }

  /**
   * Checks if the given component Id is a parent component. Returns true if the component
   * is a parent.
   * @param componentId The id of the component we want to know is a parent or child.
   */
  isParent(componentId: number): boolean {
    //const component = this.getComponent(componentId);
    //const children = this.system.Components.filter(c => c.CompartTypeId === component.CompartTypeId && c.IsChild);
    //if (children.length > 0) {
    //  const childrenWithParent = this.system.Components.filter(c => c.CompartTypeId === component.CompartTypeId);
    //  if (childrenWithParent[0].GeneralEqUnitId === componentId) return true;
    //}
    //return false;
    const children = this.system.Components.filter(c => c.ParentComponentId === componentId && c.IsChild);
    if (children.length > 0) return true;
    return false;
  }

  AddSystemImagesArray(event:any){
    console.log("event", this.system);
if (!this.system.SystemImages) {
  this.system.SystemImages = [];
}

this.system.SystemImages.push({
  Id: 0,
  SystemId: this.system.SystemId,
  ImagePath: event.imagePath.ImagePath,
  ImageUrl: event.imagePath.ImageUrl
});
console.log("system images", this.system);
 }

 viewComponentHistoryPhoto(component: ComponentModel, IsSystemImages:boolean=false, system:any=null) {
     const viewPhotoModalRef = this._dialog.open(ComponentImageHistoryComponent, {
       width: '1300px',
       panelClass: 'custom-dialog-panel',
       data: {
         equipmentID: this.equipmentId,
         comparttypeid: component?.ComponentTypeId,
         position: component?.Pos,
         side: component?.Side,
         name: component?.Name,
         IsSystemImages: IsSystemImages,
         system: system
       }
     });
   }

    viewComponentComment() {
       let passingData;
      
         passingData = {
           inspectionId: this.inspectionId,
           comment: this.system.SystemComment,
           showplus:true,
           //CompartTypeId:this.CompartTypeId,
           ScreenId : PopupEndPoint.CreateEditInspectionComponent,
           SystemId: this.system.SystemId,
           
         };
   
       const viewCommentModalRef = this._dialog.open(ComponentCommentModalComponent, {
         width: '1032px',
         data: passingData,
       });
       viewCommentModalRef.afterClosed().subscribe(reloadComment => {
         if (reloadComment){
           if(this.system.SystemId>0 && reloadComment.ScreenId == PopupEndPoint.CreateEditInspectionComponent){
            this.system.SystemComment = reloadComment.Comment;
           }
           
         }
       });
     }
}

